module.exports = __webpack_public_path__ + "img/century.bf68c1ae.png";